
<div class="product-list-item">
  <div class="col-12 col-md-2 product-list-item-img">
    @if (product?.images) {
    <a [attr.aria-label]="
          !product?.images?.hasOwnProperty('PRIMARY')
            ? ('productDetails.noProductImage'
              | cxTranslate: { product: product?.name })
            : undefined
        " [routerLink]="{  cxRoute: 'product',params: product } | cxUrl" class="cx-product-image-container">
        <cx-media class="cx-product-image" [container]="product?.images?.PRIMARY || product?.images" format="product"
        [alt]="product?.name || product?.summary"></cx-media>
      </a>
    }
  </div>
  <div class="d-flex col-12 col-md-10 kb-product-item-login-block">
    <div class="d-flex flex-column col-md-3">
      <a [routerLink]="{  cxRoute: 'product',params: product } | cxUrl" class="cx-product-name">
        <label class="product-code" [innerHtml]="product?.code"></label>
      </a>
      <label class="label-style product-typeNumber">{{product?.typenumber}}</label>
      <label class="label-style productName" [innerHtml]="product?.name"></label>
      @if (product?.sapEan) {
        <label class="label-style" >GTIN : {{product?.sapEan}}</label>
      }


      <label class="label-style product-Statuscode"
        [ngClass]="product?.salesStatusCode=='CODE30' || product?.salesStatusCode=='CODE40' ||product?.salesStatusCode=='code30' || product?.salesStatusCode=='code40'?'green-color':''">
        @if (product?.salesStatus?.indexOf('common.')<0) {
          <span>{{product?.salesStatus}}</span>
        }
        @if (product?.salesStatus?.indexOf('common.')>-1) {
          <span>@if (product?.salesStatus) {
            <span
            >{{product?.salesStatus|cxTranslate}}</span>
          }</span>
        }
      </label>


    </div>

  </div>
</div>